export const FETCH_UPLOADED_FILES = 'FETCH_UPLOADED_FILES'
export const FETCHED_UPLOADED_FILES = 'FETCHED_UPLOADED_FILES'
export const RESET_UPLOADED_FILES = 'RESET_UPLOADED_FILES'
